import React from 'react';
import { css, colors, fonts, spacing, StyleSheet } from '../../../../../styles';

/**
 * Renders a titled group of related integration controls.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.title
 */
export const DetailsSection = ({ children, title }) => (
    <section className={css(styles.section)}>
        <p className={css(styles.title)}>{title}</p>
        {children}
    </section>
);

const styles = StyleSheet.create({
    section: {
        marginBottom: spacing.s4
    },
    title: {
        ...fonts.smBold,
        color: colors.black,
        marginBottom: spacing.s3
    }
});
